"use client";
import * as React from "react";
import { Box, Skeleton, Typography } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import PlaceIcon from "@mui/icons-material/Place";
import { useState } from "react";
import { ApiService } from "../../services/AppService";
import { getToken } from "../../services/HolderService";
import { Address, ResponseObject } from "../../classes/main";
import { AddressInputDialog } from "./AddressInputDialog";

interface LocationDialogProps {
  setCloseDialog: any;
  setLocation: any;
  setLoading: any;
}

const AddressLocationDialog: React.FC<LocationDialogProps> = ({
  setCloseDialog,
  setLocation,
  setLoading,
}) => {
  const apiService = React.useMemo(() => new ApiService(), []);
  const [open, setOpen] = useState(false);
  const [address, setAddress] = useState<undefined>(undefined);
  const [updateAddress, setUpdateAddress] = React.useState(false);
  const [addresses, setAddresses] = useState<Address[]>([]);
  const [updateAddressFlag, setUpdateAddressFlag] = React.useState(false);
  // const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  // const [selectedAddress, setSelectedAddress] = React.useState<any>(null);

  // const openDropDown = Boolean(anchorEl);

  // const handleClick = (event: React.MouseEvent<HTMLElement>, address: any) => {
  //   event.stopPropagation();
  //   setAnchorEl(event.currentTarget);
  //   setSelectedAddress(address); // Store the selected addres
  // };

  // const handleCloseAddressDropdown = () => {
  //   setAnchorEl(null);
  // };

  // const handleUpdateAddress = async (selectedAddress: any) => {
  //   setAddress(selectedAddress);
  //   handleCloseAddressDropdown();
  //   setOpen(true);
  //   setUpdateAddressFlag(true);
  // };

  // const handleDeleteAddress = async (selectedAddress: any) => {
  //   try {
  //     const responseObject: ResponseObject =
  //       await apiService.delete<ResponseObject>(
  //         apiService.deleteCustomerAddresses +
  //           "?addressId=" +
  //           selectedAddress?.id,
  //         getToken()!
  //       );
  //   } catch (error) {
  //     console.log("Error:", error);
  //   }
  //   handleCloseAddressDropdown();
  //   setUpdateAddress(true);
  // };

  const getAddresses = React.useCallback(async () => {
    const responseObject = await apiService.get<ResponseObject>(
      apiService.customerAddresses,
      getToken()!
    );
    if (responseObject?.status == "success") {
      setAddresses(responseObject.object);
    }
  }, [apiService]);

  React.useEffect(() => {
    getAddresses();
    setUpdateAddress(false);
  }, [updateAddress, getAddresses]);

  //   React.useEffect(() => {
  //     const addressFromLocalStorage = JSON.parse(
  //       atob(localStorage.getItem("address") as string)
  //     );
  //     console.log(addressFromLocalStorage, "addressFromLocalStorage--------");
  //     setAddress(addressFromLocalStorage);
  //   }, []);

  const handleClickOpen = () => {
    const addressFromStorage = JSON.parse(
      atob(localStorage.getItem("address") as string)
    );
    setOpen(true);
    setAddress({
      ...addressFromStorage,
      building: "",
      locality: "",
      formattedAddress: "",
    });
  };

  const handleClose = () => {
    setOpen(false);
    setUpdateAddressFlag(false);
  };

  function selectAddress(item: any) {
    localStorage.setItem("address", btoa(JSON.stringify(item)));
    setLocation({
      latitude: item?.latitude,
      longitude: item?.longitude,
    });
    setCloseDialog();
    setLoading(true);
  }

  return (
    <React.Fragment>
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            flexDirection: { xs: "column", sm: "row" },
            gap: 1.5,
            padding: "0.15rem 0 0.9rem",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontFamily: "var(--salontym-font-display)",
                fontSize: { xs: "1.2rem", sm: "1.35rem" },
                lineHeight: 1.1,
                color: "#102117",
              }}
            >
              Saved addresses
            </Typography>
            <Typography
              sx={{
                marginTop: "0.35rem",
                fontSize: "0.92rem",
                color: "#66756b",
                lineHeight: 1.7,
              }}
            >
              Pick a saved address or add a new one to continue booking nearby
              services.
            </Typography>
          </Box>
          <Box
            onClick={handleClickOpen}
            sx={{
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: "0.5rem",
              padding: "0.8rem 1rem",
              borderRadius: "999px",
              background:
                "linear-gradient(135deg, rgba(223,246,232,0.95), rgba(255,240,216,0.95))",
              boxShadow: "0 16px 30px rgba(18, 53, 36, 0.08)",
              color: "#145635",
              fontWeight: 700,
              fontSize: "0.92rem",
              userSelect: "none",
            }}
          >
            <AddCircleIcon sx={{ fontSize: "1.2rem" }} />
            Add New Address
          </Box>
        </Box>
        <Box
          sx={{
            display: "grid",
            gap: "0.9rem",
          }}
        >
          {addresses.length > 0 ? (
            addresses.map((item, index) => (
                <Box
                  key={"AddressCard" + index}
                  onClick={() => selectAddress(item)}
                  sx={{
                    width: "100%",
                    minHeight: "2rem",
                    borderRadius: "22px",
                    border: "1px solid rgba(18,53,36,0.08)",
                    background:
                      "linear-gradient(180deg, rgba(255,255,255,0.96), rgba(246,251,248,0.96))",
                    boxShadow: "0 18px 40px rgba(18, 53, 36, 0.08)",
                    padding: "1rem",
                    position: "relative",
                    cursor: "pointer",
                    transition: "transform 180ms ease, box-shadow 180ms ease",
                    "&:hover": {
                      transform: "translateY(-2px)",
                      boxShadow: "0 24px 46px rgba(18, 53, 36, 0.12)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      gap: "0.85rem",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "flex-start",
                        gap: "0.8rem",
                      }}
                    >
                      <Box
                        sx={{
                          width: "2.5rem",
                          height: "2.5rem",
                          minWidth: "2.5rem",
                          borderRadius: "16px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background:
                            "linear-gradient(135deg, rgba(223,246,232,1), rgba(255,240,216,0.95))",
                          color: "#145635",
                        }}
                      >
                        <PlaceIcon sx={{ fontSize: "1.1rem" }} />
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            fontWeight: 700,
                            fontSize: "0.98rem",
                            color: "#102117",
                            lineHeight: 1.45,
                          }}
                        >
                          {item?.formattedAddress ?? ""}
                        </Typography>
                        <Typography
                          sx={{
                            marginTop: "0.28rem",
                            fontSize: "0.87rem",
                            color: "#607066",
                            lineHeight: 1.75,
                          }}
                        >
                          {item?.building ?? ""}
                          {item?.building && item?.locality ? ", " : ""}
                          {item?.locality ?? ""}
                        </Typography>
                      </Box>
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "0.74rem",
                        fontWeight: 700,
                        color: "#145635",
                        background: "rgba(223,246,232,0.85)",
                        borderRadius: "999px",
                        padding: "0.32rem 0.62rem",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Select
                    </Typography>
                    {/* <Box>
                    <IconButton
                      size="large"
                      aria-label="display more actions"
                      edge="end"
                      color="inherit"
                      onClick={(event) => handleClick(event, address)}
                    >
                      <MoreIcon />
                    </IconButton>
                  </Box> */}
                  </Box>
                  {/* <Box
                  sx={{
                    position: "absolute",
                    bottom: "12px",
                    right: "12px",
                  }}
                >
                  <Button
                    variant="outlined"
                    color="success"
                    onClick={() => selectAddress(address)}
                    sx={{
                      textTransform: "capitalize",
                    }}
                  >
                    select
                  </Button>
                </Box> */}
                  {/* <Menu
                  anchorEl={anchorEl}
                  id="account-menu"
                  open={openDropDown}
                  onClose={handleCloseAddressDropdown}
                  // onClick={handleCloseAddressDropdown}
                  slotProps={{
                    paper: {
                      elevation: 0,
                      sx: {
                        overflow: "visible",
                        filter: "drop-shadow(0px 1px 2px rgba(0,0,0,0.1))",
                        mt: 1.5,
                        "& .MuiAvatar-root": {
                          width: 32,
                          height: 32,
                          ml: -0.5,
                          mr: 1,
                        },
                        "&::before": {
                          content: '""',
                          display: "block",
                          position: "absolute",
                          top: 0,
                          right: 14,
                          width: 10,
                          height: 10,
                          bgcolor: "background.paper",
                          transform: "translateY(-50%) rotate(45deg)",
                          zIndex: 0,
                        },
                      },
                    },
                  }}
                  transformOrigin={{
                    horizontal: "right",
                    vertical: "top",
                  }}
                  anchorOrigin={{
                    horizontal: "right",
                    vertical: "bottom",
                  }}
                >
                  <MenuItem
                    onClick={() => handleUpdateAddress(selectedAddress)}
                  >
                    Update Address
                  </MenuItem>
                  <MenuItem
                    onClick={() => handleDeleteAddress(selectedAddress)}
                  >
                    Delete Address
                  </MenuItem>
                </Menu> */}
                </Box>
              ))
          ) : addresses ? (
            <Box
              sx={{
                borderRadius: "24px",
                border: "1px dashed rgba(18,53,36,0.16)",
                background: "rgba(247, 250, 247, 0.82)",
                padding: "1.25rem",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 700,
                  color: "#102117",
                  fontSize: "0.98rem",
                }}
              >
                No saved addresses yet
              </Typography>
              <Typography
                sx={{
                  marginTop: "0.35rem",
                  fontSize: "0.88rem",
                  color: "#66756b",
                  lineHeight: 1.7,
                }}
              >
                Add your home or work address to make location selection faster
                next time.
              </Typography>
            </Box>
          ) : (
            Array.from({ length: 3 }).map((_, i) => (
                <Skeleton
                  key={i}
                  variant="rounded"
                  sx={{
                    width: "100%",
                    height: "120px",
                    borderRadius: "22px",
                  }}
                />
              ))
          )}
        </Box>
      </Box>
      <AddressInputDialog
        addressForSave={address}
        addressOpen={open}
        handleClose={handleClose}
        updateAddressList={() => setUpdateAddress(true)}
        updateAddressFlag={updateAddressFlag}
      />
    </React.Fragment>
  );
};

export default AddressLocationDialog;
